/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostAssignmentDataSourcePathParams = NonNullable<
  operations['postAssignmentDataSource']['parameters']['path']
>;

export type PostAssignmentDataSourceRequestBody = OperationRequestBodyContent<operations['postAssignmentDataSource']>;

export interface Input extends PostAssignmentDataSourcePathParams {
  apiVersion?: string;
  body: PostAssignmentDataSourceRequestBody;
}

export async function postAssignmentDataSource(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projKey}/assignment-data-sources', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
